module.exports = __webpack_public_path__ + "static/media/zhanghaodenglu1.3672be14.png";